import React from "react";
import "./DashboardBenefitTick.css";

const DashboardBenefitTick = ({ className = "" }) => (
  <svg
    className={`dashboard-benefit-tick ${className}`.trim()}
    viewBox="0 0 17.0273 17.0109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M16.3965 9.44283C15.7659 12.596 13.3885 15.5645 10.0515 16.2283C6.71448 16.8921 3.32815 15.3399 1.65272 12.3786C-0.0226976 9.41732 0.39092 5.71522 2.67858 3.19671C4.96625 0.678189 8.82895 -0.0166149 11.9821 1.24465"
      stroke="#067647"
      strokeWidth="1.26126"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.67579 8.18157L8.82895 11.3347L16.3965 3.13652"
      stroke="#067647"
      strokeWidth="1.26126"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DashboardBenefitTick;
